// @ts-strict-ignore
import { ArticleVO } from '@article/model/vo/article.vo';
import { PropertyVO } from '@project/components/article/model/vo/property.vo';
import { IOperation } from '@shared/undo/operation/i-operation';
import { BasePropertyOperation } from './base-property-operation';
import { ProjectModel } from '@project/model/project.model';
import { AdminService } from '../services/admin.service';
import { ConnectionUtils } from '@3d-scene/model3d/util/connection-utils';

export class ChangeArticlePropertyOperation extends BasePropertyOperation implements IOperation {
  constructor(
    originalProperty: PropertyVO,
    private _newProperty: PropertyVO,
    private _article: ArticleVO,
    private _newPropertyType: string,
    originalPropertyType: string,
    projectModel: ProjectModel,
    connectionUtils: ConnectionUtils,
    adminService: AdminService,
  ) {
    super(originalProperty, originalPropertyType, projectModel, connectionUtils, adminService);
  }

  public getQualifiedClassName(): string {
    return 'ChangeConnectionPropertyOperation';
  }

  public getOperationDescription(): string {
    return 'changedArticlePropertyOperation.description';
  }

  public async performRedo(): Promise<void> {
    this.redoArticlePropertyChanges(this._newProperty, this._newPropertyType, this._article);
  }

  public async performUndo(): Promise<void> {
    this.undoArticlePropertyChanges(this._newProperty, this._newPropertyType, this._article);
  }
}
